module.exports = __webpack_public_path__ + "img/intel-celeron.bd1a4894.jpg";